import { render, staticRenderFns } from "./AttrGrid.vue?vue&type=template&id=f010b0c4&scoped=true&"
import script from "./AttrGrid.vue?vue&type=script&lang=js&"
export * from "./AttrGrid.vue?vue&type=script&lang=js&"
import style0 from "./AttrGrid.vue?vue&type=style&index=0&id=f010b0c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f010b0c4",
  null
  
)

export default component.exports